"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimizedFileToFile = exports.isFullFileFieldValue = exports.isOptimizedFile = exports.isOptimizedFileFieldValue = exports.isFileFieldValue = void 0;
const dates_1 = require("./dates");
const objects_1 = require("./objects");
const primitives_1 = require("./primitives");
const typing_1 = require("./typing");
const arrays_1 = require("./arrays");
const string_1 = require("./string");
const utils_1 = require("../file-field/utils");
/**
 * Type guard for FileFieldValue
 * @param fieldValue
 */
const isFileFieldValue = (fieldValue) => {
    return (0, arrays_1.isArrayOfValidObjectsValue)(fieldValue, {
        handle: primitives_1.isStringValue,
        created_on: (0, typing_1.Optional)((0, typing_1.Union)(dates_1.isDateAsStringValue, string_1.isEmptyStringValue)),
        updated_on: (0, typing_1.Optional)((0, typing_1.Union)(dates_1.isDateAsStringValue, string_1.isEmptyStringValue)),
        metadata: (0, typing_1.Optional)(objects_1.isObjectLikeValue),
        transform_options: (0, typing_1.Optional)(objects_1.isObjectLikeValue),
    }, true);
};
exports.isFileFieldValue = isFileFieldValue;
/**
 * Checks if the provided value is a preview file value.
 * @param fieldValue
 */
const isOptimizedFileFieldValue = (fieldValue) => {
    return (0, arrays_1.isArrayOfValidObjectsValue)(fieldValue, {
        handle: primitives_1.isStringValue,
        name: (0, typing_1.Optional)(primitives_1.isStringValue),
        mimetype: (0, typing_1.Optional)(primitives_1.isStringValue),
        size: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
        container: (0, typing_1.Optional)(primitives_1.isStringValue),
        key: (0, typing_1.Optional)(primitives_1.isStringValue),
        video_conversion_status: (0, typing_1.Optional)(primitives_1.isStringValue),
        video_thumbnail_handle: (0, typing_1.Optional)(primitives_1.isStringValue),
        converted_video_handle: (0, typing_1.Optional)(primitives_1.isStringValue),
    });
};
exports.isOptimizedFileFieldValue = isOptimizedFileFieldValue;
/**
 * Type guard for OptimizedFile
 * @param file
 */
const isOptimizedFile = (file) => {
    return (0, objects_1.isValidObjectValue)(file, {
        handle: primitives_1.isStringValue,
        name: (0, typing_1.Optional)(primitives_1.isStringValue),
        mimetype: (0, typing_1.Optional)(primitives_1.isStringValue),
        size: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
        video_conversion_status: (0, typing_1.Optional)(primitives_1.isStringValue),
        video_thumbnail_handle: (0, typing_1.Optional)(primitives_1.isStringValue),
        converted_video_handle: (0, typing_1.Optional)(primitives_1.isStringValue),
    });
};
exports.isOptimizedFile = isOptimizedFile;
const isFullFileFieldValue = (fieldValue) => {
    if (!(0, arrays_1.isArrayValue)(fieldValue))
        return false;
    return fieldValue.every((obj) => {
        var _a;
        if (!(0, objects_1.isObjectLikeValue)(obj))
            return false;
        const metadata = (_a = obj === null || obj === void 0 ? void 0 : obj.metadata) !== null && _a !== void 0 ? _a : {};
        return ("handle" in obj &&
            "metadata" in obj &&
            "mimetype" in metadata &&
            "filename" in metadata &&
            "size" in metadata &&
            "created_on" in obj &&
            "updated_on" in obj);
    });
};
exports.isFullFileFieldValue = isFullFileFieldValue;
const optimizedFileToFile = (file) => {
    var _a, _b, _c, _d, _e;
    const { handle, name, mimetype, size, container, key, ...other } = file;
    return {
        ...other,
        handle: handle !== null && handle !== void 0 ? handle : "",
        metadata: {
            mimetype: mimetype !== null && mimetype !== void 0 ? mimetype : "",
            filename: name !== null && name !== void 0 ? name : "",
            size: size !== null && size !== void 0 ? size : 0,
            container: container !== null && container !== void 0 ? container : "",
            key: key !== null && key !== void 0 ? key : "",
        },
        file_type: (0, utils_1.getFileType)((_a = file === null || file === void 0 ? void 0 : file.mimetype) !== null && _a !== void 0 ? _a : ""),
        icon: (0, utils_1.getIconByMimeType)((_b = file === null || file === void 0 ? void 0 : file.mimetype) !== null && _b !== void 0 ? _b : ""),
        video_conversion_status: (_c = other === null || other === void 0 ? void 0 : other.video_conversion_status) !== null && _c !== void 0 ? _c : "none",
        video_thumbnail_handle: (_d = other.video_thumbnail_handle) !== null && _d !== void 0 ? _d : "",
        converted_video_handle: (_e = other.converted_video_handle) !== null && _e !== void 0 ? _e : "",
    };
};
exports.optimizedFileToFile = optimizedFileToFile;
